/**
 * Canonical helper for the `originHostname` field the FE sends to the BE.
 *
 * Every endpoint that rebuilds a FE URL for an outbound email CTA — account
 * verification, password reset, order confirmation, wholesale invitation,
 * anything with a "click here" link — needs the customer's ORIGIN including
 * the port so the reconstructed URL lands on the exact same dev server the
 * customer was on. In dev that's `zaveato.pk.local:5173`; in prod the port
 * is the scheme default and `.host` strips it automatically, so prod hosts
 * are unchanged from `.hostname`.
 *
 * SRP: THE single source of truth for "which browser host string do we send
 * to the BE for URL reconstruction". Never call `window.location.hostname`
 * for this purpose — hostname drops the port and produces
 * `http://zaveato.local/...` which refuses to connect in dev.
 *
 * Non-email uses (region detection, `X-WL-Host` header, API-base
 * resolution) legitimately want `hostname` and are OUT of scope for this
 * helper — they must not include the dev port.
 */
export function getOriginHostForEmailCta(): string | undefined {
  if (typeof window === 'undefined') return undefined
  // `host` = "example.com" or "example.com:8443". Default ports for the
  // current scheme (80 for http, 443 for https) are auto-omitted, so prod
  // hostnames render as bare hostnames just like `hostname` did before.
  return window.location.host
}
